import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'

const app = createApp(App)

app.config.globalProperties.$ENDPOINT = process.env.VUE_APP_ENDPOINT

app.use(router)
app.mount('#app')

// PWA (service worker)
import('./registerServiceWorker')